import { render, staticRenderFns } from "./SideBarRightItem.vue?vue&type=template&id=4de78fcb&scoped=true"
import script from "./SideBarRightItem.vue?vue&type=script&lang=js"
export * from "./SideBarRightItem.vue?vue&type=script&lang=js"
import style0 from "./SideBarRightItem.vue?vue&type=style&index=0&id=4de78fcb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de78fcb",
  null
  
)

export default component.exports